<template>
  <div class="toastBox fCol jEnd aEnd">
    <div class="toast fRow jStart aCenter"
    v-for="item in this.$store.state.toastData" v-bind:key="item.id"
    v-bind:style="{background: item.bg}" >
      <i class="material-icons-round ic">{{item.ic}}</i>
      <div class="msg">{{item.msg}}</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    toastData() {
      // console.log('toast data is => ', this.$store.state.toastData[0].bg);
      return this.$store.state.toastData;
    },
  },
};
</script>

<style lang='scss' scoped>
@keyframes a {
  0% {
    box-shadow: 0 0 0 0 rgba($color: #ffffff, $alpha: 0.2);
  }
  100% {
    box-shadow: 0 0 0 24px rgba($color: #ffffff, $alpha: 0.0);
  }
}
  .toastBox{
    z-index: 9999999999999999000099999999999;
    position: fixed;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    cursor: pointer;
  }

  .toastBox *{
    pointer-events: none;
  }

  .toast {
    border-radius: 64px;
    box-shadow: 0 4px 16px 0 rgba($color: #000000, $alpha: 0.2);
    padding: 12px 16px;
    animation: a 1.5s infinite cubic-bezier(0.5, 0, 0, 0.8);
    margin-bottom: 12px;
  }

  .toast .ic{
    color: white;
    margin-left: 16px;
    cursor: pointer;
  }

  .toast .msg{
    font-size: 14px;
    font-weight: 300;
    line-height: 1.5;
    text-align: right;
    color: white;
  }

  @media screen and (max-width: 400px) {
    .toastBox{
      left: 16px;
      right: 16px;
      transform: unset;
      -webkit-transform: unset;
      -ms-transform: unset;
      -moz-transform: unset;
      -o-transform: unset;
    }
  }
</style>
